import { SfSelectOption } from 'ngx-smart-form';

export interface CmsCities {
  data: {
    municipalities: {
      data: {
        attributes: {
          code: string;
          default: boolean;
          historic: string;
          name: string;
          province: string;
          sign: string;
          cadastral: string;
        };
      }[];
    };
  };
}

export class Cities {
  static getOptions(data?: CmsCities) {
    const options =
      data?.data.municipalities.data.map((el) => ({
        value: el.attributes.name,
        view: el.attributes.name,
        code: el.attributes.cadastral,
      })) || [];
    return options;
  }
}
